import React from 'react'
import _ from 'lodash'
import { Tooltip } from 'react-tooltip'

import ReportTable from '../report_table'
import MemberTableOrg from './report_member_table'
import * as Helper from '../../../../helpers/helper'
import * as Constants from '../../../../helpers/constants'
import { getCountUpCell, localeNumberFormatter, truncateEnd } from '../helpers'

// port of cowebapp analytics/components/email_verifier/report_org_table.js
const ReportTableOrg = (props) => {

  const emailFormatter = (cell, row) => {
    return (
      <div
        className="d-flex org-email-column"
        title={row.email}
      >
        <div className='word-break-all'>
          {truncateEnd(Helper.capitalizeFirstLetter(_.isEmpty(row.name) ? '-' : row.name), 17)}
          <small>
            <div className="d-flex">
              <span className='word-break-all'>
                {truncateEnd(row.email, 23)}
              </span>
            </div>
          </small>
        </div>
      </div>
    )
  }

  const bounceFormatter = (cell) => {
    if (cell != 0) {
      return getCountUpCell(cell, { precision: 0, suffix: '%' })
    } else {
      return '-'
    }
  }

  const estCostFormatter = (cell) => {
    if (cell != 0) {
      const title = cell > 999 ? Number(cell).toFixed(2).toLocaleString() : ''
      return getCountUpCell(cell, { precision: 2, prefix: '$', title })
    } else {
      return '-'
    }
  }

  const getStsColor = (cell) => {
    if (cell < 5) {
      return 'rgba(254, 27, 27, 0.63)'
    } else if (cell < 15 && cell >= 5) {
      return 'rgba(248, 98, 22, 0.61)'
    } else if (cell < 50 && cell >= 15) {
      return 'rgba(255, 211, 15, 0.56)'
    } else if (cell < 80 && cell >= 50) {
      return 'rgba(0, 246, 255, 0.56)'
    } else {
      return 'rgba(0, 255, 111, 0.56)'
    }
  }

  const getStsTitle = (cell) => {
    if (cell < 5) {
      return 'Extermely Low Deliverabilities'
    } else if (cell < 15 && cell >= 5) {
      return 'Low Deliverabilities'
    } else if (cell < 50 && cell >= 15) {
      return 'Moderate Deliverabilities'
    } else if (cell < 80 && cell >= 50) {
      return 'High Deliverabilities'
    } else {
      return 'Extermely High Deliverabilities'
    }
  }

  const stsFormatter = (cell, row) => {
    if (cell != 0) {
      let title = getStsTitle(cell)
      let backgroundColor = getStsColor(cell)
      let width = Math.round(cell) + '%'
      return (
        <div data-tooltip-id={`sts-${row.user_id}`}>
          <div
            className="stat-value sts"
            style={{ backgroundColor: backgroundColor, width: width, marginBottom: '0px' }}
          >
            {getCountUpCell(cell, { precision: 0, suffix: '%' })}
            <Tooltip id={`sts-${row.user_id}`}>{title}</Tooltip>
          </div>
        </div>
      )
    } else {
      return (
        <div style={{ textAlign: 'right' }}>
          {'-'}
        </div>
      )
    }
  }

  const noDataIndication = () => {
    return (
      <div
        className="list-container text-center bg-white"
        style={{ padding: '10px' }}
      >
        <p className="m-0">
          No Activity Found
        </p>
      </div>
    )
  }

  const getDataLength = (id) => {
    let length = []
    props.tableData.forEach((data) => {
      if (data.user_id === id) {
        data.stats.forEach((st) => {
          if (st.safe_to_send > 0) {
            length.push({ st })
          }
        })
      }
    })
    return length.length
  }

  const calculateBounceRate = (unknown, invalid, total) => {
    let bounceRate = 0
    let count = total - unknown
    if (total !== 0) {
      bounceRate = (Number(invalid) / Number(count) * 100)
    }
    return bounceRate > 0 ? bounceRate : 0
  }

  const calculateEstimatedCostSaved = (count) => {
    let costSaved = 0
    costSaved = (Number(count) * Constants.AVG_EMAIL_SENDING_COST)
    return costSaved
  }

  const getTableData = () => {
    let tableData = []
    props.tableData.forEach((data) => {
      let dataLength = Number(getDataLength(data.user_id))
      let total = 0
      let valid = 0
      let invalid = 0
      let catch_all = 0
      let unknown = 0
      let safe_to_send = 0
      let billable = 0
      data.stats.forEach((stat) => {
        total = total + stat.total
        valid = valid + stat.valid
        invalid = invalid + stat.invalid
        catch_all = catch_all + stat.catch_all
        unknown = unknown + stat.unknown
        billable = billable + stat.billable
        safe_to_send = safe_to_send + stat.safe_to_send
      })

      tableData.push({
        email: data.email,
        stats: data.stats,
        user_id: data.user_id,
        name: data.name,
        role: data.role,
        total: total,
        valid: valid,
        invalid: invalid,
        catch_all: catch_all,
        unknown: unknown,
        billable: billable,
        bounce_detected: calculateBounceRate(unknown, invalid, total),
        cost_saved: calculateEstimatedCostSaved(invalid),
        safe_to_send: isNaN(safe_to_send / dataLength) ? 0 : (safe_to_send / dataLength)
      })

    })
    return tableData
  }

  const data = getTableData()
  const rowClasses = 'custom-row-class'
  const formatNumber = localeNumberFormatter('-')

  const columns = [
    {
      dataField: 'email',
      text: 'Member',
      formatter: emailFormatter,
      headerStyle: { width: '19%' },
      style: { width: '19%' },
      sort: true
    },
    {
      dataField: 'total',
      text: 'Total Verified',
      headerStyle: { width: '9%' },
      style: { width: '9%' },
      formatter: formatNumber,
      align: 'right',
      sort: true,
      headerTitle: () => 'Total Verified includes Duplicate'
    },
    {
      dataField: 'bounce_detected',
      text: 'Bounce Detected',
      headerStyle: { width: '9%' },
      style: { width: '9%' },
      formatter: bounceFormatter,
      align: 'right',
      sort: true
    },
    {
      dataField: 'cost_saved',
      text: 'Est. Cost Saved (USD)',
      headerStyle: { width: '9%' },
      style: { width: '9%' },
      formatter: estCostFormatter,
      align: 'right',
      sort: true
    },
    {
      dataField: 'safe_to_send',
      text: 'Safe to Send',
      headerStyle: { width: '9%' },
      style: { width: '9%' },
      formatter: stsFormatter,
      sort: true
    },
    {
      dataField: 'valid',
      text: 'Valid',
      headerStyle: { width: '9%' },
      style: { width: '9%' },
      formatter: formatNumber,
      align: 'right',
    },
    {
      dataField: 'invalid',
      text: 'Invalid',
      headerStyle: { width: '9%' },
      style: { width: '9%' },
      formatter: formatNumber,
      align: 'right',
    },
    {
      dataField: 'catch_all',
      text: 'Catch All',
      headerStyle: { width: '9%' },
      style: { width: '9%' },
      formatter: formatNumber,
      align: 'right',
    },
    {
      dataField: 'unknown',
      text: 'Unknown',
      headerStyle: { width: '9%' },
      style: { width: '9%' },
      formatter: formatNumber,
      align: 'right',
    },
    {
      dataField: 'billable',
      text: 'Billable Credits',
      headerStyle: { width: '9%' },
      style: { width: '9%' },
      formatter: formatNumber,
      align: 'right',
      sort: true
    }
  ]

  const expandRow = {
    className: 'expanding-row',
    parentClassName: 'parent-expand-row',
    renderer: row => (
      <MemberTableOrg
        memberData={row.stats}
        breakdown={props.userReportData.breakdown}
        id={row.user_id}
      />
    ),
  }

  const defaultSorted = [{
    dataField: 'total',
    order: 'desc'
  }]

  return (
    <div className="report-table">
      <ReportTable
        wrapperClasses="table-report-org table-responsive"
        expandRow={expandRow}
        noDataIndication={noDataIndication}
        keyField="user_id"
        data={data}
        columns={columns}
        rowClasses={rowClasses}
        defaultSorted={defaultSorted}
      />
    </div>
  )
}

export default ReportTableOrg
